import {z} from "zod/v4-mini"

export const definition = {
    validation: {
        returns: z.any(),
        parameters: z.object({
            args: z.any(),
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            fn: z.custom<(args: any) => any>((value) => typeof value === "function"),
        }),
    },
}
